import { faStar as star } from '@fortawesome/free-regular-svg-icons';
import { faStar as solidStar } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { userInstrumentsSlice } from '!core/redux';

import { FavoriteIcon } from './TrlLeftSlot.styles';

export const TrlLeftSlot = ({ option }) => {
  const dispatch = useDispatch();

  const isFavourite = option.isFavourite === 'Y';
  const isDisabledSetFavourite = !option.instrument;

  const handleFavorite = (e) => {
    e.stopPropagation();
    dispatch(
      userInstrumentsSlice.actions.setFavInstrumentRequest({
        option: isFavourite ? 'D' : 'I',
        instrument: option.instrument,
        symbol: option.symbol,
        exchange: option.exchange,
        securityType: option.securityType,
      }),
    );
  };

  return (
    <FavoriteIcon
      disabled={isDisabledSetFavourite}
      icon={isFavourite ? solidStar : star}
      onClick={(e) => {
        if (!isDisabledSetFavourite) handleFavorite(e);
      }}
    />
  );
};

TrlLeftSlot.propTypes = {
  option: PropTypes.object,
};
